import React from 'react';
import styles from '../styles.less';
import { formatNumber, formatRate } from '../staticData';

/** 顶部四个统计卡片 */
const StatCards = ({ total, success, error, videoRate }) => {
  const cards = [
    {
      label: '生成总次数',
      extra: '（所有账号）',
      value: formatNumber(total),
      unit: '次',
    },
    { label: '生成成功', value: formatNumber(success), unit: '次' },
    { label: '生成失败', value: formatNumber(error), unit: '次' },
    { label: '成功率', value: formatRate(videoRate, 2) },
  ];

  return (
    <div className={styles.statCards}>
      {cards.map((item) => (
        <div className={styles.statCard} key={item.label}>
          <div className={styles.statLabel}>
            <span>{item.label}</span>
            {item.extra && (
              <span className={styles.statExtra}>{item.extra}</span>
            )}
          </div>
          <div className={styles.statValue}>
            {item.value}
            {item.unit && <span className={styles.statUnit}>{item.unit}</span>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatCards;
